module.exports = __webpack_public_path__ + "img/header-memoireRingsRedgold.107f6ad.jpg";